import { render, staticRenderFns } from "./RegistroPreaspirante.vue?vue&type=template&id=60285b62&scoped=true"
import script from "./RegistroPreaspirante.vue?vue&type=script&lang=js"
export * from "./RegistroPreaspirante.vue?vue&type=script&lang=js"
import style0 from "./RegistroPreaspirante.vue?vue&type=style&index=0&id=60285b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60285b62",
  null
  
)

export default component.exports